<template>
    <div class="map">
        <div id="map"></div>
        <nav class="map-controls">
          <button class="map-controls__filters" @click="filtersVisible=!filtersVisible">
            <svg viewBox="0 0 32 32"><path d="M10,8H3A1,1,0,0,1,3,6h7a1,1,0,0,0,0,2Z"></path><path d="M30,7a1,1,0,0,1-1,1H10a1,1,0,0,0,0-2H29A1,1,0,0,1,30,7Z"></path><path d="M22,17H3a1,1,0,0,1,0-2H22a1,1,0,0,0,0,2Z"></path><path d="M30,16a1,1,0,0,1-1,1H22a1,1,0,0,0,0-2h7A1,1,0,0,1,30,16Z"></path><path d="M10,26H3a1,1,0,0,1,0-2h7a1,1,0,0,0,0,2Z"></path><path d="M30,25a1,1,0,0,1-1,1H10a1,1,0,0,0,0-2H29A1,1,0,0,1,30,25Z"></path><path d="M11.73,24A2,2,0,1,0,12,25,2,2,0,0,0,11.73,24ZM9,25a1,1,0,1,1,1,1A1,1,0,0,1,9,25Z"></path><path d="M12.82,24a3,3,0,0,0-5.64,0,2.87,2.87,0,0,0,0,2,3,3,0,0,0,5.64,0,2.87,2.87,0,0,0,0-2ZM11,25a1,1,0,1,1-1-1A1,1,0,0,1,11,25Z"></path><path d="M23.73,15A2,2,0,1,0,24,16,2,2,0,0,0,23.73,15ZM21,16a1,1,0,1,1,1,1A1,1,0,0,1,21,16Z"></path><path d="M24.82,15a3,3,0,0,0-5.64,0,2.87,2.87,0,0,0,0,2,3,3,0,0,0,5.64,0,2.87,2.87,0,0,0,0-2ZM23,16a1,1,0,1,1-1-1A1,1,0,0,1,23,16Z"></path><path d="M11.73,6A2,2,0,1,0,12,7,2,2,0,0,0,11.73,6ZM9,7a1,1,0,1,1,1,1A1,1,0,0,1,9,7Z"></path><path d="M12.82,6A3,3,0,0,0,7.18,6a2.87,2.87,0,0,0,0,2,3,3,0,0,0,5.64,0,2.87,2.87,0,0,0,0-2ZM11,7a1,1,0,1,1-1-1A1,1,0,0,1,11,7Z"></path></svg>
          </button>
          <button class="map-controls__location" ref="locationButton">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 48.2">
              <path d="M23.5,48.2L24,25.1L0,24.6L51,0L23.5,48.2z"/>
            </svg>
          </button>
        </nav>
        <form class="filters" ref="filters" v-bind:class="{'is-visible':filtersVisible}">
          <label class="label-radio">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 8 8"><circle cx="4" cy="4" r="4" fill="rgba(32, 33, 63, 1)"></circle></svg>
            <input type="radio" checked name="layer" value="audios" v-model="layerDisplayed">
            <span class="label">Enregistrements</span>
            <span class="fake-radio"></span>
          </label>
          <label class="label-radio">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 8 8"><circle cx="4" cy="4" r="4" fill="#F07A87"></circle></svg>
            <input type="radio" name="layer" value="boxes" v-model="layerDisplayed">
            <span class="label">Points fixes</span>
            <span class="fake-radio"></span>
          </label>
        </form>
        <div class="map-info-container">
          <div class="map-info" v-bind:class="{ 'is-visible': infoVisible }" ref="mapInfo">
            <div class="map-info__content">
              <div>
                  <div class="map-info__btn map-info__site">
                    <svg viewBox="0 0 21 28" fill="#3B345D"><path d="M9.42,27.42C1.47,15.91,0,14.73,0,10.5C0,4.7,4.7,0,10.5,0S21,4.7,21,10.5c0,4.23-1.47,5.41-9.42,16.93 C11.05,28.18,9.94,28.18,9.42,27.42z M10.5,14.87c2.42,0,4.38-1.96,4.38-4.38s-1.96-4.38-4.38-4.38s-4.38,1.96-4.38,4.38 S8.08,14.87,10.5,14.87z"/></svg>
                    <span>{{ location.Site }}</span>
                  </div>
                  <div class="map-info__group">
                    <div class="map-info__btn map-info__habitat">
                      <span>{{ location.hab1 ? location.hab1 : '-' }}</span>
                    </div>
                    <div class="map-info__btn map-info__operator">
                      <svg viewBox="0 0 42.8 38.19" stroke="#3B345D" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" fill="none"><path d="M21.18,22.69a7.65,7.65,0,0,1-4.4-1.41,11.37,11.37,0,0,1-4.49-9.39c0-6,4-10.8,8.89-10.8s8.88,4.84,8.88,10.8a11.4,11.4,0,0,1-4.34,9.29l-.14.11A4.38,4.38,0,0,0,28.17,25l4.91,2.18a4.39,4.39,0,0,1,2.61,4v3.34A2.59,2.59,0,0,1,33.1,37.1H9.7a2.59,2.59,0,0,1-2.59-2.59V31.12a4.39,4.39,0,0,1,2.54-4L14.25,25a4.39,4.39,0,0,0,2.51-3.51"></path></svg>
                      <span>{{ location.ope }}</span>
                    </div>
                  </div>
              </div>
              <ul class="map-info__audios">
                <li class="map-info__audio map-info__btn" v-for="(group, index) in audiosGrouped" v-bind:key="index">
                  <div class="map-info__when">
                    <svg viewBox="0 0 24 24" fill="#3B345D"><path d="M19.434,4.566h-2.478V3.327c0-0.685-0.555-1.239-1.239-1.239c-0.684,0-1.239,0.554-1.239,1.239v1.239H9.522V3.327  c0-0.685-0.555-1.239-1.239-1.239c-0.684,0-1.239,0.554-1.239,1.239v1.239H4.566c-1.368,0-2.478,1.11-2.478,2.478v12.39  c0,1.368,1.11,2.478,2.478,2.478h14.868c1.368,0,2.478-1.11,2.478-2.478V7.044C21.912,5.675,20.802,4.566,19.434,4.566z   M19.434,19.434H4.566V8.902h14.868V19.434z"></path></svg>
                    <span>{{ group.when }}</span>
                  </div>
                  <div class="map-info__amount">
                    <p>{{ group.amount }} enregistrements</p>
                  </div>
                </li>
              </ul>
            </div>
            <div class="map-info-close">
              <button class="map-info-close__btn" @click="closeInfo">
                <svg viewBox="0 0 100 100"><path d="M91.82,100A8.15,8.15,0,0,1,86,97.6L2.4,14A8.18,8.18,0,0,1,14,2.4L97.6,86a8.19,8.19,0,0,1-5.78,14Z"></path><path d="M8.18,100A8.19,8.19,0,0,1,2.4,86L86,2.4A8.18,8.18,0,1,1,97.6,14L14,97.6A8.15,8.15,0,0,1,8.18,100Z"></path></svg>
              </button>
            </div>
          </div>
        </div>
    </div>
</template>

<style lang="scss">
    .map {
      flex-basis: 100%;
      display: flex;
      position: relative;
      background: lighten(#8CF0D4, 20);
    }
    .map-controls {
      position: fixed;
      top: 0.5em;
      right: 0.5em;
      button {
        background: #3B345D;
        width: 40px;
        height: 40px;
        font-size: 27px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 0 1px 0;
        padding: 0;
      }
    }
    .filters {
      position: absolute;
      top: 0.5em;
      right: calc(0.5em + 40px + 10px);
      background: white;
      border: 3px solid #3B345D;
      padding: 10px;
      color: #3B345D;
      transform: translateY(-100%) translateY(-0.5em);
      transition: 0.2s ease-out;
      &.is-visible {
        transform: translateY(0);
      }
    }
    .label-radio {
      padding: 10px;
      display: block;
      display: flex;
      align-items: center;
      svg {
        margin-right: 10px;
      }
      input {
        opacity: 0;
        position: absolute;
        z-index: -1;
      }
      .label {
        margin-right: 10px;
        display: inline-block;
      }
      .fake-radio {
        display: block;
        width: 20px;
        height: 20px;
        background: #3B345D;
        margin-left: auto;
        position: relative;
        &:before {
          content: '';
          position: absolute;
          top: 2px;
          left: 2px;
          width: 16px;
          height: 16px;
          background: white;
          transform: scale(1);
          transition: 0.2s ease-out;
        }
      }
      input:checked ~ .fake-radio:before {
        transform: scale(0);
      }
    }
    .label-radio.is-reversed {
      padding-left: 0;
      .fake-radio {
        width: 22px;
        height: 22px;
        background: white;
        &:before {
          top: 3px;
          left: 3px;
          background: #3B345D;
          transform: scale(0);
        }
      }
      input:checked ~ .fake-radio:before {
        transform: scale(1);
      }
    }
    .map-controls__filters {
      background: none;
      border: none;
      svg {
        width: 25px;
        fill: white;
      }
    }
    .map-controls__location {
      display: block;
      background: none;
      border: none;
      padding: .5em;
      cursor: pointer;
      svg {
        width: 22px;
        fill: white;
      }
    }
    .ol-control {
      background: none;
      padding: 0;
    }
    .ol-control button {
      background-color: #3B345D;
      width: 40px;
      height: 40px;
      margin: 0 0 1px 0;
    }
    #map {
        width: 100%;
        height: calc(100% + 25px);
    }
    .map-info-container {
      position: absolute;
      bottom: -25px;
      right: 0;
      pointer-events: none;
      overflow: hidden;
      width: 100%;
      height: 40vh;
    }
    .map-info {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: auto;
      background: url('../assets/img/bg-3.svg') center bottom / cover;
      color: white;
      border: 1px solid black;
      padding: 0 10px 30px 10px;
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      transform: translateY(100%) translateY(25px);
      transition: 0.3s ease-out;
    }
    .map-info__content {
      min-height: 30vh;
      padding-top: 40px;
    }
    .map-info-close {
      position: sticky;
      bottom: calc(100% - 35px);
      text-align: right;
      svg {
        width: 20px;
        fill: white;
      }
    }
    .map-info-close__btn {
      background: none;
      border: none;
    }
    .map-info__btn {
      background: white;
      border-radius: 10px;
      padding: 15px;
      color: #20213F;
      font-weight: 400;
      display: flex;
      align-items: center;
      font-size: 20px;
      line-height: 1.2;
    }
    .map-info__group {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 15px;
      margin-top: 15px;
    }
    .map-info__site svg {
      width: 20px;
      margin-right: 10px;
      flex-shrink: 0;
    }
    .map-info__when {
      display: flex;
      align-items: center;
      svg {
        width: 20px;
        margin-right: 10px;
      }
    }
    .map-info__amount {
      margin-left: auto;
    }
    .map-info__habitat {
      font-size: 18px;
      line-height: 1.2;
    }
    .map-info__operator {
      font-size: 18px;
      line-height: 1.2;
      svg {
        width: 30px;
        margin-right: 10px;
        flex-shrink: 0;
        font-size: 20px;
      }
    }
    .map-info__audios {
      margin-top: 15px;
    }
    .map-info__audio {
      display: flex;
    }
    .map-info.is-visible {
        transform: translateY(0%);
    }
    .map-info li + li {
        margin-top: 10px;
    }
    .map-info p {
        margin: 0;
    }
</style>

<script>
import 'ol/ol.css'
import { Map, View } from 'ol'
import Feature from 'ol/Feature'
import TileLayer from 'ol/layer/Tile'
import VectorLayer from 'ol/layer/Vector'
import { fromLonLat } from 'ol/proj'
import Point from 'ol/geom/Point'
import OSM from 'ol/source/OSM'
import VectorSource from 'ol/source/Vector'
import { Style, Icon } from 'ol/style'
import Geolocation from 'ol/Geolocation.js'

export default {
  data () {
    return {
      layerDisplayed: 'audios',
      location: {},
      infoVisible: false,
      filtersVisible: false,
      audios: [],
      prevLocation: null,
      markerStyle: null
    }
  },
  computed: {
    audiosGrouped: function () {
      let dates = []
      this.audios.forEach((audio) => {
        let isNew = true
        // Check if group exists already
        dates.forEach((date) => {
          if (date.when === audio.Night_Date) {
            isNew = false
            date.amount++
          }
        })

        if (isNew) {
          dates.push({
            when: audio.Night_Date,
            amount: 1
          })
        }
      })
      return dates
    }
  },
  methods: {
    closeInfo () {
      this.infoVisible = false
      this.prevLocation.setStyle(this.markerStyle)
    }
  },
  mounted () {
    var data = require('../assets/signals.json')
    var dataFixed = require('../assets/fixedLocations.json')

    const belgiumCenterMercator = fromLonLat([4.8, 50.2])
    const view = new View({
      center: belgiumCenterMercator,
      zoom: 7.5
    })
    const map = new Map({
      target: 'map',
      layers: [
        new TileLayer({
          source: new OSM()
        })
      ],
      view: view
    })

    map.interactions.removeAt(0)
    map.interactions.removeAt(2)
    map.controls.removeAt(2) // Remove attributions on the map

    window.addEventListener('resize', () => {
      setTimeout(() => {
        map.updateSize()
      }, 1000)
    })

    const markerIcon = new Icon({
      crossOrigin: 'anonymous',
      src: 'mapCircle.svg',
      size: [10, 10],
      anchor: [0.5, 0.5]
    })
    const boxIcon = new Icon({
      crossOrigin: 'anonymous',
      src: 'mapCircleBox.svg',
      size: [16, 16],
      anchor: [0.5, 0.5]
    })
    this.markerStyle = new Style({
      image: markerIcon
    })
    const boxStyle = new Style({
      image: boxIcon
    })
    boxIcon.load()
    markerIcon.load()
    const markerActiveIcon = new Icon({
      crossOrigin: 'anonymous',
      src: 'mapPin.svg',
      size: [25.2, 33.6],
      anchor: [0.5, 1]
    })
    markerActiveIcon.load()
    const markerStyleActive = new Style({
      image: markerActiveIcon
    })

    let locations = []
    let audiosMarkers = []

    /* Create dots for audios */
    data.forEach((point) => {
      // Check if the dot is already on the map
      let isNew = true
      locations.forEach((box, index) => {
        if (box.x === point.X && box.y === point.Y) {
          isNew = false
          point.location = index
          box.recordings.push(point)
        }
      })

      if (isNew) {
        var marker = new Feature({
          geometry: new Point(fromLonLat([point.Y, point.X]))
        })
        point.location = locations.length
        marker.location = locations.length
        audiosMarkers.push(marker)
        marker.data = point
        locations.push({
          x: point.X,
          y: point.Y,
          recordings: [point]
        })
      }
    })

    var audiosVectorSource = new VectorSource({
      features: audiosMarkers
    })

    var audiosVectorLayer = new VectorLayer({
      source: audiosVectorSource,
      map: map
    })
    audiosVectorLayer.setStyle(this.markerStyle)

    /* FIXED POINTS */
    var boxesMarkers = []
    dataFixed.forEach((box) => {
      var marker = new Feature({
        geometry: new Point(fromLonLat([box.y, box.x]))
      })
      box.location = locations.length
      marker.location = locations.length
      boxesMarkers.push(marker)
      marker.data = box
    })
    var boxesVectorSource = new VectorSource({
      features: boxesMarkers
    })
    var boxesVectorLayer = new VectorLayer({
      source: boxesVectorSource,
      map: map,
      visible: false
    })
    boxesVectorLayer.setStyle(boxStyle)

    map.on('pointermove', checkFeaturesHover)
    var elMap = document.getElementById('map')
    function checkFeaturesHover (e) {
      var features = map.getFeaturesAtPixel(e.pixel, {
        hitTolerance: 5
      })
      if (features) {
        elMap.style.cursor = 'pointer'
      } else {
        elMap.style.cursor = 'auto'
      }
    }
    map.on('click', (e) => {
      var features = map.getFeaturesAtPixel(e.pixel, {
        hitTolerance: 5
      })
      if (features) {
        features[0].setStyle(markerStyleActive)
        this.audios = locations[features[0].location].recordings
        this.location = locations[features[0].location].recordings[0]
        if (this.prevLocation) {
          this.prevLocation.setStyle(this.markerStyle)
        }
        this.prevLocation = features[0]
        this.infoVisible = true
        this.$refs.mapInfo.scrollTop = 0
        // Zoom on the pin
        requestAnimationFrame(() => {
          view.animate({
            center: features[0].getGeometry().getCoordinates(),
            zoom: 11,
            duration: 500
          })
        })
      } else {
        this.infoVisible = false
        if (this.prevLocation) {
          this.prevLocation.setStyle(this.markerStyle)
        }
      }
    })

    /* Geolocation people */
    var geolocation = new Geolocation({
      trackingOptions: {
        enableHighAccuracy: true
      },
      projection: view.getProjection()
    })
    var positionFeature = new Feature()
    var locationIcon = new Icon({
      crossOrigin: 'anonymous',
      src: 'mapPosition.svg',
      size: [40, 40]
    })
    var locationIconStyle = new Style({
      image: locationIcon
    })
    locationIcon.load()
    positionFeature.setStyle(locationIconStyle)
    var geoVectorSource = new VectorSource({
      features: [positionFeature]
    })
    var geoVectorLayer = new VectorLayer({
      source: geoVectorSource,
      map: map
    })
    geoVectorLayer.setStyle(boxStyle)

    geolocation.on('change:position', () => {
      var coordinates = geolocation.getPosition()
      positionFeature.setGeometry(coordinates ? new Point(coordinates) : null)
    })
    this.$refs.locationButton.addEventListener('click', () => {
      geolocation.setTracking(true)
    })

    /* ============ */
    /*   FILTERS    */
    /* ============ */
    this.$refs.filters.addEventListener('change', (e) => {
      if (this.layerDisplayed === 'audios') {
        audiosVectorLayer.setVisible(true)
        boxesVectorLayer.setVisible(false)
      } else {
        audiosVectorLayer.setVisible(false)
        boxesVectorLayer.setVisible(true)
      }
      map.render()
    })
  }
}
</script>
